import { Component, Input } from '@angular/core';


@Component({
    selector: 'app-input-label',
    imports: [],
    templateUrl: './input-label.component.html'
})
export class InputLabelComponent {
  @Input() label?: string;
  @Input() isOptional = true;
}
